<fury-page>
    <fury-title class="title">
        <h2>Loader Content</h2>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="loaderContentForm">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            
            <div>
                <span>
                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>Loader Title Content</mat-label>
                    <input matInput placeholder="Loader Title Content" formControlName="loaderTitleContent">
                    <mat-error *ngIf="loaderContentForm.controls['loaderTitleContent'].touched && loaderContentForm.controls['loaderTitleContent'].hasError('required')">
                        This is a required field.</mat-error>
                  </mat-form-field>
                </span>
                <span>
                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>Loader Initial Content</mat-label>
                    <input matInput placeholder="Loader Initial Content" formControlName="loaderInitialContent">
                    <mat-error *ngIf="loaderContentForm.controls['loaderInitialContent'].touched && loaderContentForm.controls['loaderInitialContent'].hasError('required')">
                        This is a required field.</mat-error>
                  </mat-form-field>
                </span>
                <span>
                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>Loader Progress Content</mat-label>
                    <input matInput placeholder="Loader Progress Content" formControlName="loaderProgressContent">
                    <mat-error *ngIf="loaderContentForm.controls['loaderProgressContent'].touched && loaderContentForm.controls['loaderProgressContent'].hasError('required')">
                        This is a required field.</mat-error>
                  </mat-form-field>
                </span>
                <span>
                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-label>Loader Warning Content</mat-label>
                    <input matInput placeholder="Loader Warning Content" formControlName="loaderWarningContent">
                    <mat-error *ngIf="loaderContentForm.controls['loaderWarningContent'].touched && loaderContentForm.controls['loaderWarningContent'].hasError('required')">
                        This is a required field.</mat-error>
                  </mat-form-field>
                </span>
              </div>
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button"
            (click)="updateLoaderContent()"><span>Update</span></button>
          </div>
            
          </form>
    </div>
  </div>
